export const SIGNING_ORDERS = {
  PRESERVED: 'preserved',
  RANDOM: 'random',
};